const getToken = () => {
  const cookies = document.cookie.split(';')

  for (let i = 0; i < cookies.length; i++) {
    if (cookies[i].search('authorization=Bearer') >= 0) {
      return cookies[i].replace('authorization=Bearer ', '').trim()
    }
  }

  return ''
}

const setToken = (token) => {
  const date = new Date()
  const expiresDays = 10
  date.setTime(date.getTime() + (expiresDays * 24 * 60 * 60 * 1000))
  document.cookie = `authorization=Bearer ${token};expires=${date.toUTCString()};SameSite=Strict`
}

const getPayload = (token) => {
  let base64Url = token.split('.')[1]
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  let jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''))

  return JSON.parse(jsonPayload)
}

const removeToken = () => {
  document.cookie = 'authorization=; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
}

export default { getToken, setToken, removeToken, getPayload }



//////////////////
// WEBPACK FOOTER
// ./my_modules/authentication/index.js
// module id = null
// module chunks = 